import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=3274f32c&scoped=true&"
import script from "./NotificationDropDown.vue?vue&type=script&lang=ts&"
export * from "./NotificationDropDown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=3274f32c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274f32c",
  null
  
)

export default component.exports